import React from 'react';
import classnames from 'classnames';
import './LocationItem.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faMap from '@fortawesome/fontawesome-free-solid/faMap';
import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
import faMarker from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt';

const LocationItem = props => {
  const { data, isOnMap } = props;

  return <div className={classnames({"location-item": true, 'isOnMap': isOnMap})}>
    <div className="location-item-column is-flex-2 location-titles">
      <div className="location-name-title">{data.name}</div>
      {data.sub_title && <div className="location-name-sub-title">{data.sub_title}</div>}
    </div>
    <div className="location-item-column is-flex-2">
      <div className="location-address">
        <FontAwesomeIcon className="location-info-icon" icon={faMarker} size="xs"/>
        <span>{data.address}</span>
      </div>
      <div className="location-item-row">
        {data.telephone && <div className="location-phone">
            <FontAwesomeIcon className="location-info-icon" icon={faPhone} size="xs"/>
            <span>{data.telephone}</span>
          </div>
        }
        <a className="location-map" href={`https://www.google.com/maps/place/${data.address}`} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon className="location-info-icon" icon={faMap} size="xs"/>
          <span>開啟地圖</span>
        </a>
      </div>
    </div>
    <div className="location-item-column location-custom-fields">
      {data.field1 && 
        <div className="location-field">
          <span>{data.field1}</span>
        </div>
      }
      {data.field2 && 
        <div className="location-field">
          <span>{data.field2}</span>
        </div>
      }
    </div>
  </div>
}

export default LocationItem;


// WEBPACK FOOTER //
// ./src/components/LocationItem.js